<template>
    <q-page padding>
        <div class="row q-mb-sm">
            <div class="col-xs-12 col-sm-12">
                <div class="q-display-1 text-secondary">
                    <q-icon name="fas fa-chalkboard" class="q-mb-sm" /> {{ live_class_title }}
                </div>
            </div>
        </div>

        <q-tabs v-model="tab">
            <q-tab slot="title" name="live-class" :label="$t('live_class')" />


            <q-tab-pane name="live-class">
                <live-class 
                    :platform_type="platform_type" 
                    :embed="embed" :title="live_class_title" 
                    :description="live_class_description" 
                    :room="live_class_room" 
                    :status="status" 
                    :date_class="date_class"
                    :id_presential="id_presential"
                    :id_event="id_event"
                    :managerTrainings="true" />
            </q-tab-pane>

        </q-tabs>

        <div class="row gutter-sm justify-end">
            <div class="col-xs-12 col-sm-3">
                <q-btn color="tertiary" class="full-width" :label="$t('back')" icon="fas fa-chevron-left" @click="hideModal()" />
            </div>
        </div>
    </q-page>
</template>

<script>
import LiveClassTab from 'components/admin/live_classe/LiveClassTab'

export default {
    name: 'AdminPresentialLiveClassModal',

    // id_presential and id_event will be received only for presential training live classes
    props: ['live_class', 'id_presential', 'id_event', 'date_class'],

    data() {
        return {
            id_live_class: '',
            live_class_type: '',
            live_class_room: '',
            live_class_title: '',
            live_class_description: '',
            status: 4,
            platform_type: 1,
            embed: null,
            tab: 'live-class',
        }
    },

    components: {
        'live-class': LiveClassTab,
    },

    methods: {
        hideModal() {
            this.$emit('hideModal', '')
        },
    },

    mounted () {
        this.id_live_class = this.live_class.id
        this.live_class_type = this.live_class.type
        this.live_class_room = this.live_class.code_room
        this.live_class_title = this.live_class.title
        this.live_class_description = this.live_class.description
        this.status = this.live_class.status
        this.platform_type = this.live_class.platform_type
        this.embed = this.live_class.embed
    },
}
</script>

<style>

</style>
